// Tipo de pregunta «estrellas» (1-5): valor guardado = número entero 1..5 (1 = muy mal, 5 = muy bien).
// Colores coherentes con el semáforo (rojo → naranja → ámbar → verde).
export const ESTRELLAS_INFO = {
  1: { label: "Muy mal", bg: "#dc2626" },
  2: { label: "Mal", bg: "#ea580c" },
  3: { label: "Regular", bg: "#d97706" },
  4: { label: "Bien", bg: "#65a30d" },
  5: { label: "Muy bien", bg: "#16a34a" },
};

// Devuelve 1..5 o null si el valor no es una puntuación válida.
export const numEstrellas = (valor) => {
  const n = Number(valor);
  return Number.isInteger(n) && n >= 1 && n <= 5 ? n : null;
};

export const textoEstrellas = (n) => "★".repeat(n) + "☆".repeat(5 - n);
